import global$1 from './global.js';
import isRegexp from './is-regexp.js';

var global = global$1;
var isRegExp = isRegexp;
var TypeError = global.TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  }

  return it;
};

export { notARegexp as default };
